import { PropsWithChildren } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { PayoutLabel } from '../PayoutLabel';

type ValueProps = {
  className?: string;
};

export const Value = ({ children, className }: PropsWithChildren<ValueProps>) => {
  const { t } = useTranslation('payments');

  return (
    <>
      {children && (
        <Text size='large' weight='bold' css={{ margin: 0 }} className={className}>
          {children}
        </Text>
      )}
      {!children && <PayoutLabel>{t('Unknown')}</PayoutLabel>}
    </>
  );
};
